import { Tooltip, Legend } from "recharts";
import {
  Bar,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  ResponsiveContainer,
  LabelList,
} from "recharts";

export default function AgeDistributionMaternityLeaveChart({ data }) {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        layout="vertical"
        height={400}
        data={data}
      >
        <CartesianGrid strokeDasharray="3 3" horizontal={false} />
        <XAxis type="number" />
        <YAxis type="category" dataKey="ageGroup" />
        <Tooltip
          formatter={(value) => [
            `${value?.toLocaleString()} Teachers`,
            "Count",
          ]}
        />
        <Legend />
        <Bar
          dataKey="count"
          fill="hsl(var(--chart-1))"
          name="Teachers"
        >
          <LabelList
            dataKey="count"
            position="right"
            formatter={(value) => value.toLocaleString()}
            style={{ fill: "black", fontWeight: "bold", fontSize: 15 }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
